import { Phone, Instagram, Mail } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useContact } from "@/lib/contact";
import { useContent } from "@/context/ContentContext";

export const Footer = () => {
  const CONTACT = useContact();
  const { content } = useContent();

  return (
    <footer className="relative border-t border-slate-200 bg-[#F8F9FA]">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-16">
        <div className="grid gap-12 md:grid-cols-3">
          <div>
            <Logo />
            <p className="mt-5 text-sm leading-loose text-slate-600 max-w-xs">
              وكالة سفر في منطقة السيف بمملكة البحرين. تواصلوا معنا للاستفسار عن رحلتكم وترتيب الحجوزات.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold tracking-widest text-brand mb-5">تواصل معنا</h4>
            <ul className="space-y-3 text-sm text-slate-600">
              <li>
                <a href={CONTACT.phoneLink} className="inline-flex items-center gap-3 hover:text-brand transition-colors">
                  <Phone className="h-4 w-4 text-[#C80000]" />
                  <span dir="ltr">{CONTACT.phoneDisplay}</span>
                </a>
              </li>
              <li>
                <a href={CONTACT.whatsapp} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 hover:text-brand transition-colors">
                  <Phone className="h-4 w-4 text-[#25D366]" />
                  واتساب — تواصل معنا عبر واتساب
                </a>
              </li>
              <li>
                <a href={CONTACT.instagram} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 hover:text-brand transition-colors">
                  <Instagram className="h-4 w-4 text-[#f09433]" />
                  <span dir="ltr">{CONTACT.instagramHandle}</span>
                </a>
              </li>
              {content?.email && (
                <li>
                  <a href={`mailto:${content.email}`} data-testid="footer-email-link" className="inline-flex items-center gap-3 hover:text-brand transition-colors">
                    <Mail className="h-4 w-4 text-[#C80000]" />
                    <span dir="ltr">{content.email}</span>
                  </a>
                </li>
              )}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold tracking-widest text-brand mb-5">عنوان المكتب</h4>
            <p className="text-sm leading-loose text-slate-600">{CONTACT.addressAr}</p>
            <p dir="ltr" className="mt-2 text-xs leading-relaxed text-slate-500 text-right">{CONTACT.addressEn}</p>
            {content?.workingHours && <p className="mt-3 text-sm text-slate-600">ساعات العمل: {content.workingHours}</p>}
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-slate-200">
          <div className="text-xs text-slate-500 text-center sm:text-start space-y-1">
            <p>© 2026 دليل المسافر للحجوزات — Travelers Guide. جميع الحقوق محفوظة.</p>
            {(content?.legalName || content?.crNumber) && (
              <p data-testid="footer-legal-info">
                {content?.legalName && <span>{content.legalName}</span>}
                {content?.legalName && content?.crNumber && <span> · </span>}
                {content?.crNumber && <span>سجل تجاري: <span dir="ltr">{content.crNumber}</span></span>}
              </p>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
};
